import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialUnzerReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const unzerSlice = createSlice({
    name: "Unzer",
    initialState: { ...initialUnzerReducer },
    reducers: {
        ...integrationReducerActions,
        importDataRequest(state) {
            state.submitted = true;
            state.isImportLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
        },
        importDataSuccess(state, action) {
            if (action.payload) {
                state.configuration = action.payload;
                state.editConfiguration = action.payload;
            }
            state.isImportLoading = false;
            state.imported = true;
            state.importSuccessMessage = "Der Import wurde erfolgreich gestartet";
        },
        importDataFailure(state, action) {
            state.isImportLoading = false;
            state.imported = false;
            state.importErrorMessage = action.payload;
        },
        getPaymentStatementsRequest(state, action) {
            state.getPaymentStatementsLoading = true;
            state.getPaymentStatementsErrorMessage = null;
        },
        getPaymentStatementsSuccess(state, action) {
            state.getPaymentStatementsLoading = false;
            state.paymentStatements = action.payload;
        },
        getPaymentStatementsFailure(state, action) {
            state.getPaymentStatementsLoading = false;
            state.getPaymentStatementsErrorMessage = action.payload;
        },
        getPaymentStatementTransactionsRequest(state, action) {
            state.getPaymentStatementTransactionsLoading = true;
            state.getPaymentStatementTransactionsErrorMessage = null;
        },
        getPaymentStatementTransactionsSuccess(state, action) {
            state.getPaymentStatementTransactionsLoading = false;
        },
        getPaymentStatementTransactionsFailure(state, action) {
            state.getPaymentStatementTransactionsLoading = false;
            state.getPaymentStatementTransactionsErrorMessage = action.payload;
        },
        deletePaymentStatementRequest(state, action) {
            state.deletePaymentStatementLoading = true;
            state.deletePaymentStatementErrorMessage = null;
        },
        deletePaymentStatementSuccess(state, action) {
            state.deletePaymentStatementLoading = false;
            if (
                action.payload &&
                state.paymentStatements &&
                state.paymentStatements.content &&
                state.paymentStatements.content.length > 0
            ) {
                state.paymentStatements = {
                    ...state.paymentStatements,
                    content: state.paymentStatements.content.filter((statement) => statement.id !== action.payload),
                };
            }
        },
        deletePaymentStatementFailure(state, action) {
            state.deletePaymentStatementLoading = false;
            state.deletePaymentStatementErrorMessage = action.payload;
        },
        resetImportDataErrors(state) {
            state.getPaymentStatementsErrorMessage = null;
            state.getPaymentStatementTransactionsErrorMessage = null;
            state.deletePaymentStatementErrorMessage = null;
        },
    },
});

export default unzerSlice;
